<ng-template #loading>
    <div class="loading-wrapper">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<h3>{{ 'reservation.headings.reserve' | translateSafe }}</h3>
<div class="store-information" *ngIf="storesService.allStores$ | async as stores; else loading">
    <h3 class="display-5">{{ 'reservation.headings.chosenStore' | translateSafe }}</h3>
    <div class="description" *ngIf="stores | findStoreFromId: reserveInStore?.storeId || '' as store">
        <h4 class="display-7">{{ store.storeName }}</h4>
        <span>{{ store.address }}</span>
        <span>{{ store.postalCode }} {{ store.city }}</span>
    </div>
</div>

<form [formGroup]="form" appHandleInvalidOnSubmit (ngSubmit)="onSubmit()">
    <h3 class="display-5 form-headline">{{ 'reservation.headings.userInformation' | translateSafe }}</h3>
    <div class="form-content">
        <div class="inputs">
            <app-input-email
                [control]="form.controls.customerEmail"
                [label]="'forms.labels.email' | translateSafe"
                [placeholder]="'forms.placeholders.email' | translateSafe"
                marginBottom="small"
            >
            </app-input-email>
            <app-input
                [control]="form.controls.customerName"
                [label]="'forms.labels.fullName' | translateSafe"
                [placeholder]="'forms.placeholders.fullName' | translateSafe"
                [maxlength]="50"
                autocomplete="name"
                marginBottom="small"
            ></app-input>
            <app-input-phone
                [control]="form.controls.customerMobile"
                [label]="'forms.labels.phoneNumber' | translateSafe"
                [placeholder]="'forms.placeholders.phoneNumber' | translateSafe"
                marginBottom="small"
            >
            </app-input-phone>
        </div>

        <ng-container *ngIf="(settingsService.settings$ | async)?.ecommerceSettings as settings">
            <app-checkbox [control]="form.controls.customerConsent" marginBottom="small">
                <span
                    class="kk-rte"
                    appInterceptLinks
                    [innerHTML]="settings.reservationConsentCheckbox | safe: 'html'"
                ></span>
            </app-checkbox>

            <div
                *ngIf="settings.reservationInfo"
                class="kk-rte info"
                appInterceptLinks
                [innerHTML]="settings.reservationInfo | safe: 'html'"
            ></div>
        </ng-container>
    </div>

    <div class="buttons">
        <button type="submit" class="kk-btn" [disabled]="(form.statusChanges | async) === 'INVALID'">
            <ng-container *ngIf="!submitting">{{ 'reservation.buttons.reserve' | translateSafe }}</ng-container>
            <app-loading-dots *ngIf="submitting" class="spinner"></app-loading-dots>
        </button>

        <button type="button" class="kk-btn kk-btn_secondary" (click)="updateEvent.emit({ event: 'CANCEL' })">
            {{ 'general.action.cancel' | translateSafe }}
        </button>
    </div>
</form>
